export enum TipoRecapitoAnagrafeEnum {
  PEC = <any>"PEC",
  APACI = <any>"APACI",
  CARTACEO = <any>"CARTACEO",
  MAIL = <any>"MAIL",
  PORTALE_WEB = <any>"PORTALE_WEB",
}
